import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { reduxForm } from 'redux-form';
import ButtonGroup from '../../components/button-group';
import { VideoIcon } from '../icons';
import textEditorVideoEmbedFormSettings from '../../services/text-editor-video-embed-form-settings';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './text-editor-video-embed-form.scss';

const getFieldProps = field => ({
  value: field.value,
  onChange: field.onChange,
  onFocus: field.onFocus,
  onBlur: field.onBlur,
});
const TextEditorVideoEmbedForm = ({
  fields: { url },
  dirty,
  invalid,
  handleSubmit,
  onCancel,
  t,
  contentFontClassName,
}) =>
  <div className={classNames(styles.container, contentFontClassName, 'forum-text-color')}>
    {dirty &&
      invalid &&
      url &&
      <div className={styles.error}>
        {t('text-editor-video-embed-form.invalid-url')}
      </div>}
    <h3 className={styles.title}>
      <VideoIcon className={classNames(styles.icon, 'forum-icon-fill')}/>
      <span>
        {t('text-editor-video-embed-form.add-video')}
      </span>
    </h3>
    <div className={styles.inputWrapper}>
      <input
        className={classNames(styles.input, contentFontClassName)}
        autoFocus
        placeholder={t('text-editor-video-embed-form.placeholder')}
        {...getFieldProps(url)}
      />
      <div className={classNames(styles.border, 'forum-text-border-color')}/>
    </div>
    <ButtonGroup
      primaryButtonText={t('text-editor-video-embed-form.button')}
      primaryButtonProps={{ onClick: handleSubmit }}
      secondaryButtonText={t('text-editor-video-embed-form.cancel-button')}
      secondaryButtonProps={{ onClick: () => onCancel() }}
    />
  </div>;

TextEditorVideoEmbedForm.propTypes = {
  fields: PropTypes.object.isRequired,
  dirty: PropTypes.bool,
  invalid: PropTypes.bool,
  contentFontClassName: PropTypes.string,
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default reduxForm(textEditorVideoEmbedFormSettings)(withTranslate(withFontClassName(TextEditorVideoEmbedForm)));



// WEBPACK FOOTER //
// ./app/components/text-editor-video-embed-form/text-editor-video-embed-form.js